var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"w-100 text-center"},[_c('a',{attrs:{"href":"http://easydelivery.com.br"}},[_c('img',{staticClass:"img-fluid",style:(("width: " + _vm.width)),attrs:{"src":require("@/assets/img/easy-delivery.svg"),"alt":"logo-easy"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }